import { render, staticRenderFns } from "./SnackbarWarning.vue?vue&type=template&id=9e04bb76&scoped=true"
import script from "./SnackbarWarning.vue?vue&type=script&lang=ts"
export * from "./SnackbarWarning.vue?vue&type=script&lang=ts"
import style0 from "./SnackbarWarning.vue?vue&type=style&index=0&id=9e04bb76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e04bb76",
  null
  
)

export default component.exports